import Model, { ID, IsoDateTime } from 'src/models/Model'
import Order from 'src/models/order/Order'
import Payment from 'src/models/payment/Payment'

export const UNKNOWN_PAYMENT_STATES = {
  NEW: 'new',
  KNOWN: 'known', // We were able to link the logged stripe payment to an INDY payment or order record
  UNKNOWN: 'unknown', // We were unable to link the logged stripe payment to an INDY payment or order record
  HANDLED: 'unknown-handled' // We were unable to link the logged stripe payment to an INDY payment or order record, but the payment has been resolved
}

export const UNKNOWN_PAYMENT_HANDLED_TYPES = {
  REFUNDED: 'Refunded in Stripe', // We were able to refund the stripe payment
  UNRELATED: 'Unrelated Charge', // The stripe payment was for a charge not related to INDY Cinema
  OTHER: 'Other' // A non-standard action was taken to resolve the payment, refer to notes
}

export default class UnknownPayment extends Model {
  static name = 'UnknownPayment'

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      state: {
        type: String,
        output: true,
        default: UNKNOWN_PAYMENT_STATES.UNKNOWN,
        options: UNKNOWN_PAYMENT_STATES,
        sortable: true
      },
      handledType: {
        type: String,
        default: UNKNOWN_PAYMENT_HANDLED_TYPES.OTHER,
        options: Object.values(UNKNOWN_PAYMENT_HANDLED_TYPES),
        sortable: true
      },
      stripePaymentIntentId: {
        type: String,
        default: null,
        sortable: true
      },
      order: {
        type: Order,
        reference: true,
        output: true
      },
      payment: {
        type: Payment,
        reference: true,
        output: true
      },
      notes: {
        type: String,
        default: null
      },
      createdAt: {
        type: IsoDateTime,
        output: true,
        sortable: true
      }
    }

    this.computed = {
      draft () {
        return this.state === 'draft'
      },
      operative () {
        return this.state === 'draft' || this.state === 'completed' || this.state === 'disputed' || this.state === 'lost_dispute'
      },
      completed () {
        return this.state === 'completed' || this.state === 'disputed' || this.state === 'lost_dispute'
      }
    }

    this.paginate = true
  }
}
